import { getGstData } from '@app/components/Cart';

export const cloneOrderCart = (cart: Record<string, unknown> | null | undefined) => {
    if (!cart) return {};
    const copy: Record<string, unknown> = {};
    Object.entries(cart).forEach(([key, val]) => {
        if (val && typeof val === 'object' && (val as { selected?: number }).selected) {
            copy[key] = { ...(val as object) };
        }
    });
    return copy;
};

export const sanitizeEditCart = (cart: Record<string, any>) => {
    const out: Record<string, any> = {};
    Object.entries(cart || {}).forEach(([key, val]) => {
        if (val?.selected > 0) {
            out[key] = val;
        }
    });
    return out;
};

export const computeBillFieldsFromCart = (editCart: Record<string, any>, order: any) => {
    const gstRate = order?.gstRate ?? order?.restaurant?.gstRate ?? 0;
    const serviceRate = order?.serviceRate ?? order?.restaurant?.serviceRate ?? 0;
    const isGstBill = !!order?.isGstBill;
    const discount = Number(order?.discount) || 0;

    let itemsCost = 0;
    Object.values(editCart).forEach((cartItem: any) => {
        if (cartItem?.selectedVariants?.value && cartItem?.selected) {
            itemsCost += cartItem.selectedVariants.value * cartItem.selected;
        }
    });

    const { gstData, totalGSTCost } = getGstData(editCart, isGstBill, gstRate, itemsCost);
    const serviceBill = isGstBill
        ? Number((itemsCost * serviceRate / 100).toFixed(2))
        : 0;
    const totalCost = Math.round(
        itemsCost +
            Math.ceil(totalGSTCost) +
            (itemsCost * (isGstBill ? serviceRate : 0)) / 100 -
            discount
    );

    return {
        cart: editCart,
        itemsCost,
        gstBill: totalGSTCost || 0,
        gstData: gstData || {},
        serviceBill,
        totalCost,
    };
};
